import { createReducer, on } from '@ngrx/store';

import {
  fetchFlightCabinSuccessAction,
  fetchFlightCabinErrorAction
} from '@flight-results/store/actions/flights-results.actions';
import { FlightCabin } from '@shared/flight-itinerary/entities/cabin-types';

export const initialState: FlightCabin = null;

export const flightCabinSelectedReducer = createReducer(
  initialState,
  on(fetchFlightCabinSuccessAction, (state, { flightCabin }) => {
    return flightCabin;
  }),
  on(fetchFlightCabinErrorAction, () => initialState)
);
